<template>
  <div class="mt-8 flex flex-row gap-9" data-testid="iq-stats">
    <div class="grow-0">
      <span class="block text-body-l">{{ quotaAvailableText }}</span>
      <span class="block text-body-s">{{ t('InvitationQuota.CrewQuota.available') }}</span>
    </div>

    <div class="relative grow-0">
      <div class="absolute top-1 -left-2 h-[45px] w-px bg-surface-elevation-5"></div>
      <span class="block text-body-l">{{ counts.activated }}</span>
      <span class="block text-body-s">{{ t('InvitationQuota.CrewQuota.activated') }}</span>
    </div>

    <div class="relative grow-0">
      <div class="absolute top-1 -left-2 h-[45px] w-px bg-surface-elevation-5"></div>
      <span class="block text-body-l">{{ counts.requested }}</span>
      <span class="block text-body-s">{{ t('InvitationQuota.CrewQuota.requested') }}</span>
    </div>

    <div v-if="showDeactivationFeature" class="relative grow-0">
      <div class="absolute top-1 -left-2 h-[45px] w-px bg-surface-elevation-5"></div>
      <span class="block text-body-l">{{ counts.deactivated }}</span>
      <span class="block text-body-s">{{ t('InvitationQuota.CrewQuota.deactivated') }}</span>
    </div>

    <div class="relative grow-0">
      <div class="absolute top-1 -left-2 h-[45px] w-px bg-surface-elevation-5"></div>
      <span class="block text-body-l">{{ counts.swapped }}</span>
      <span class="block text-body-s">{{ t('InvitationQuota.CrewQuota.swapped') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { InvitationQuotaQuery } from '@/gql/myomr'

import useQuotaConfig, { type InternalQuotaTypeEnum } from './quotaConfig'
import type { TicketCounts } from './ticketCounts'

const { t } = useI18n()

const props = defineProps<{
  counts: TicketCounts['countData']
  invitationQuota: InvitationQuotaQuery['invitationQuota']
}>()

const quotaConfig = useQuotaConfig(props.invitationQuota.kind as InternalQuotaTypeEnum)

const showDeactivationFeature = computed(() => quotaConfig.value.showDeactivationFeature)

const quotaAvailableText = computed(() => {
  return t('EventInvitations.quotaOf', {
    availableCount: Math.max(props.invitationQuota.maxUsable - (props.counts.activated || 0), 0),
    maxUsable: props.invitationQuota.maxUsable,
  })
})
</script>
